import { useEffect, useState } from "react";
import PixelBlast from "@/components/PixelBlast";
import { ACTIVE_URL } from "@/constants";

interface Partner {
  id: number;
  name: string;
  logo_url: string;
  website_url?: string;
}

export function Partners() {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${ACTIVE_URL}/api/partners/`)
      .then(r => r.json())
      .then(setPartners)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-root">
      <div className="absolute inset-0 z-0 opacity-30">
        <PixelBlast
          variant="circle"
          pixelSize={5}
          color="#00d9d9"
          patternScale={5}
          patternDensity={1.2}
          pixelSizeJitter={0}
          enableRipples
          rippleSpeed={0.4}
          rippleThickness={0.22}
          rippleIntensityScale={3}
          liquid={false}
          liquidStrength={0.12}
          liquidRadius={1.2}
          liquidWobbleSpeed={5}
          speed={0.5}
          edgeFade={0.25}
          transparent
        />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto px-8 py-24">
        <h1 className="text-4xl font-bold text-white mb-4">Οι Συνεργάτες μας</h1>
        <p className="text-white/60 mb-12 text-lg">Περισσότερα από <span className="text-[#00d9d9]">1.000</span> σημεία εξαργύρωσης σε όλη την Ελλάδα</p>
        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="aspect-square bg-white/10 rounded-xl animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {partners.map((partner) => {
              const card = (
                <div className="flex flex-col items-center gap-3 group">
                  <div className="w-full aspect-square bg-white rounded-xl overflow-hidden border border-white/10 flex items-center justify-center p-3 transition-all duration-300 ease-out group-hover:border-[#00d9d9] group-hover:-translate-y-1 group-hover:shadow-[0_10px_30px_-10px_rgba(0,216,219,0.5)] group-hover:scale-[1.03]">
                    <img
                      src={partner.logo_url}
                      alt={partner.name}
                      className="w-full h-full object-contain transition-transform duration-300 ease-out group-hover:scale-110"
                    />
                  </div>
                  <span className="text-white/70 text-xs font-medium text-center uppercase tracking-wide transition-colors duration-300 group-hover:text-[#00d9d9]">{partner.name}</span>
                </div>
              );
              return partner.website_url ? (
                <a
                  key={partner.id}
                  href={partner.website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  {card}
                </a>
              ) : (
                <div key={partner.id}>{card}</div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
